import React from "react";
import Pagination from "@mui/material/Pagination";
import { listingRange } from "../../hooks/useListingState";
import CompactSelect from "./CompactSelect";

const LIMIT_OPTIONS = [10, 25, 50, 100];

/**
 * Shared footer: range text + limit dropdown + pagination (tight radius).
 */
const ListingPagination = ({
  page = 1,
  limit = 10,
  total = 0,
  totalPages,
  onPageChange,
  onLimit,
  showLimit = true,
  limitOptions = LIMIT_OPTIONS,
  className = "",
}) => {
  const pages = Math.max(
    1,
    Number(totalPages) || Math.ceil((total || 0) / limit) || 1
  );
  const { from, to, total: t } = listingRange(page, limit, total);

  return (
    <div className={`ds-listing-footer ${className}`.trim()}>
      <p className="ds-listing-range">
        Showing <strong>{from}</strong> To <strong>{to}</strong> Of{" "}
        <strong>{t}</strong> Entries
      </p>

      <div className="ds-listing-footer__controls">
        {showLimit && typeof onLimit === "function" ? (
          <CompactSelect
            size="sm"
            className="ds-filter-limit-select"
            value={limit}
            onChange={(v) => onLimit(Number(v))}
            options={limitOptions}
            ariaLabel="Rows per page"
          />
        ) : null}

        <Pagination
          count={pages}
          page={Math.min(page, pages)}
          onChange={(_, value) => onPageChange?.(value)}
          variant="outlined"
          shape="rounded"
          size="small"
          siblingCount={0}
          boundaryCount={1}
          className="ds-pagination"
          sx={{
            "& .MuiPaginationItem-root": {
              fontSize: 12,
              minWidth: 28,
              height: 28,
              margin: "0 2px",
              borderRadius: "3px",
              borderColor: "var(--border-color)",
              color: "var(--text-dark)",
              transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
            },
            "& .MuiPaginationItem-root.Mui-selected": {
              // backgroundColor: "var(--primary-color)",
              borderColor: "var(--primary-color)",
              // color: "#fff",
              "&:hover": {
                backgroundColor: "var(--primary-color)",
              },
            },
            "& .MuiPaginationItem-previousNext": {
              borderRadius: "3px",
            },
          }}
        />
      </div>
    </div>
  );
};

export default ListingPagination;
